import { UserRole } from '@app/types'
import {
  DocumentColumnKey,
  DocumentsFilters,
  DocumentsQuery,
  FileSizeBand,
} from './documents.types'

export const DOCUMENTS_QUERY_KEY = 'evidence-documents'

// Admin is implicit — not a selectable role in the assignment UI.
export const DOCUMENT_SELECTABLE_ROLES = [UserRole.VIEWER, UserRole.MEMBER]

export const PAGE_SIZE_OPTIONS = [10, 25, 50]

// Visible by default; Title is locked/always shown.
export const DEFAULT_VISIBLE_COLUMNS: DocumentColumnKey[] = [
  'category',
  'documentType',
  'dateUploaded',
  'owner',
  'tags',
  'source',
]

// Togglable extras, off by default.
export const EXTRA_COLUMNS: DocumentColumnKey[] = [
  'datePublished',
  'organisation',
  'fileSize',
  'georeferenced',
  'permissions',
]

export const COLUMN_LABELS: Record<DocumentColumnKey, string> = {
  category: 'Category',
  documentType: 'Document type',
  dateUploaded: 'Date uploaded',
  owner: 'Owner',
  tags: 'Tags',
  source: 'Source',
  datePublished: 'Date published',
  organisation: 'Organisation',
  fileSize: 'File size',
  georeferenced: 'Georeferenced',
  permissions: 'Permissions',
}

export const FILE_SIZE_BAND_LABELS: Record<FileSizeBand, string> = {
  any: 'Any',
  under1mb: 'Under 1 MB',
  '1to10mb': '1–10 MB',
  '10to100mb': '10–100 MB',
  over100mb: 'Over 100 MB',
}

export const DEFAULT_FILTERS: DocumentsFilters = {
  search: '',
  category: 'all',
  tags: [],
  organisation: '',
  source: '',
  visibility: 'all',
  georeferencedOnly: false,
  fileSizeBand: 'any',
  uploadedFrom: null,
  uploadedTo: null,
  publishedFrom: null,
  publishedTo: null,
}

export const DEFAULT_QUERY: DocumentsQuery = {
  ...DEFAULT_FILTERS,
  page: 1,
  pageSize: PAGE_SIZE_OPTIONS[0],
  sort: { field: 'created_at', direction: 'desc' },
}
